const arrayify = require('./arrayify')

const helpers = {
  arrayify,

  eq(a, b) {return a === b},

  substr(str, ...args) {return str.substr(...args)},

  stringify(obj) {return JSON.stringify(obj, null, 2)},

  formatDate(dateValue) {
    let dateString
    if (typeof dateValue['@value'] === 'string') {
      dateString = dateValue['@value']
    }
    else if (typeof dateValue === 'string') {
      dateString = dateValue
    }
    if (dateValue['@type']  === 'http://www.w3.org/2001/XMLSchema#date'
        || typeof dateValue === 'string' ) {
      let date = new Date(dateString)
      const months = ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli",
                      "August", "September", "Oktober", "November", "Dezember"]

      return [date.getDate()+".", months[date.getMonth()], date.getFullYear()].join(' ')
    }
    else if ( dateValue['@type']  === 'http://www.w3.org/2001/XMLSchema#gYear') {
      // only year component is valid for the date      
      if (dateString.charAt(0) === '-') {
        // date is before christ
        const year = parseInt(dateString.substring(1, 5), 10)
        return year.toString() + " v. Chr."
      }
      else {
        // only take the first 4 characters and remove leading zeroes
        return parseInt(dateString.substring(0, 4), 10).toString()
      }      
    }
  },
  // Enhances the preferredName with helpful distinguishing data, such as date of birth or profession
  helpfulPreferredName(obj) {
    const distinguishing = []
    if (obj.professionOrOccupationAsLiteral) distinguishing.push(...arrayify(obj.professionOrOccupationAsLiteral))
    if (obj.dateOfDeath) {
      if (obj.dateOfBirth) distinguishing.push(`${this.gYear(obj.dateOfBirth)}`)
      distinguishing.push(`—${this.gYear(obj.dateOfDeath)}`)
    }
    if (distinguishing.length === 0 && obj.biographicalOrHistoricalInformation) {
      distinguishing.push(arrayify(this.prop(obj, 'biographicalOrHistoricalInformation')).join(' '))
    }

    let ret = this.preferredName(obj)
    if (distinguishing.length)
      ret += ` (${distinguishing.join(', ')})`
    return ret
  },

  gYear(date) {
    if (typeof date['@value'] === 'string') {
      date = date['@value']
    }
    if (typeof date === 'string') {
      date = date.substring(0, 4)
    }
    return date
  },

  preferredName(obj) {
    if (obj.preferredName)
      return obj.preferredName
    const prefLabelProp = [
        'preferredNameForTheConferenceOrEvent',
        'preferredNameForTheCorporateBody',
        'preferredNameForTheFamily',
        'preferredNameForThePerson',
        'preferredNameForThePlaceOrGeographicName',
        'preferredNameForTheSubjectHeading',
        'preferredNameForTheWork',
    ].find(k => obj[k])
    if (prefLabelProp) return obj[prefLabelProp]
  },

  variantName(obj) {
      const variantLabelProp = [
          'variantNameForTheConferenceOrEvent',
          'variantNameForTheCorporateBody',
          'variantNameForTheFamily',
          'variantNameForThePerson',
          'variantNameForThePlaceOrGeographicName',
          'variantNameForTheSubjectHeading',
          'variantNameForTheWork',
      ].find(k => obj[k])
      if (variantLabelProp) return obj[variantLabelProp]
  },
  hasAny(obj, ...props) {
    return Object.keys(obj).find( k => props.indexOf(k) != -1) != undefined
  },
  prop(obj, prop) {
      if (!(prop in obj)) return ''
      if (typeof obj[prop] === 'string') {
        return obj[prop]
      }
      else if (Array.isArray(obj[prop])) {
        return obj[prop].map( value => {
          if (typeof value === 'string') {
            return value
          }
          else {
            return value['@value']
          }
        })
      }
      return obj[prop].preferredName || obj[prop]['@value'] || ''
  },

  hrefGnd(id) {    
      if (id.startsWith('http')) return id
      return 'http://d-nb.info/gnd/' + id.replace(/^gnd:/, '')
  },

  // Get a JSON object from the cache of the calling plugin, find an entry
  // with id and return its skos:prefLabel.
  //
  // NOTE: This *will* throw if the data hasn't been cached before, so make
  // sure to await a promise of cache.get(...) before executing the
  // template
  prefLabelInGraph(id, url, context, lang='de') {      
    const graph = context.data.root.self.cache.getSync(url)
    const entry = graph['@graph'].find(x => x['@id'] === id)
    if (entry) {      
      const foundValue = arrayify(entry['skos:prefLabel']).find( x => x['@language'] === lang)
      return foundValue ? foundValue['@value'] : id
    }
    else {
      return id
    }
  },
  hasBiographicalInformation(obj) {
    if( obj.dateOfBirth || obj.dateOfDeath ||
        obj.biographicalOrHistoricalInformation ) {
      return true
    }
    else {
      return false
    }
  },
  getGeometry(obj) {
    if ('geo:hasGeometry' in obj) {
      return obj['geo:hasGeometry']['geo:asWKT']['@value']
    }
    else {
      return undefined
    }
  },
  gndGender(gender) {
    const genders = {
      "gnd-gender:male": "Männlich",
      "gnd-gender:female": "Weiblich",
      "gnd-gender:notKnown": "Unbekannt"
    }
    return gender in genders ? genders[gender] : gender
  }
}

module.exports = {
  helpers,
  register() {
    require('handlebars/runtime').registerHelper(helpers)
  }
}
